module.exports = __webpack_public_path__ + "static/media/alpha_15.877a38e2.png";